import { motion } from 'framer-motion';

const fadeUp = {
  hidden: { opacity: 0, y: 20 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.5 } },
};

export default function LandingLegal() {
  return (
    <section className="pt-32 pb-24 bg-white min-h-screen">
      <div className="max-w-3xl mx-auto px-6">
        <motion.div initial="hidden" animate="visible" variants={fadeUp}>
          <h1 className="text-3xl font-light text-slate-900 mb-2" style={{ fontFamily: "'Outfit', sans-serif" }}>
            Mentions légales
          </h1>
          <p className="text-sm text-slate-400 mb-10">Dernière mise à jour : 17/04/2026</p>

          <div className="prose prose-slate prose-sm max-w-none space-y-8">
            <div>
              <p className="text-sm text-slate-500"><strong>Site :</strong> www.anticiper.net</p>
            </div>

            <div>
              <h2 className="text-lg font-semibold text-slate-900 mb-3">1. Éditeur du site</h2>
              <p className="text-sm text-slate-600 leading-relaxed mb-2">Le site internet accessible à l'adresse www.anticiper.net est édité par :</p>
              <ul className="text-sm text-slate-600 space-y-1 ml-4">
                <li><strong>Raison sociale :</strong> Anticiper</li>
                <li><strong>Forme juridique :</strong> Société par actions simplifiée unipersonnelle (SASU)</li>
                <li><strong>Siège social :</strong> Impact - BP 12 - Rue George Besse - 78330 Fontenay-le-Fleury</li>
                <li><strong>SIRET :</strong> 88523614100010</li>
                <li><strong>Numéro de TVA intracommunautaire :</strong> FR46885236141</li>
                <li><strong>Directeur de la publication :</strong> Thierry Assonion</li>
                <li><strong>Email de contact :</strong> contact@anticiper.net</li>
              </ul>
            </div>

            <div>
              <h2 className="text-lg font-semibold text-slate-900 mb-3">2. Hébergeur</h2>
              <p className="text-sm text-slate-600 leading-relaxed mb-2">Le site est hébergé par :</p>
              <ul className="text-sm text-slate-600 space-y-1 ml-4">
                <li><strong>OVH SAS</strong></li>
                <li>2 rue Kellermann – 59100 Roubaix – France</li>
                <li><strong>Téléphone :</strong> 1007</li>
                <li><strong>Site web :</strong> www.ovhcloud.com</li>
              </ul>
            </div>

            <div>
              <h2 className="text-lg font-semibold text-slate-900 mb-3">3. Propriété intellectuelle</h2>
              <p className="text-sm text-slate-600 leading-relaxed">
                L'ensemble du contenu de ce site (textes, images, vidéos, logos, graphismes, structure, etc.) est la propriété exclusive de la société Anticiper ou de ses partenaires, et est protégé par les lois françaises et internationales relatives à la propriété intellectuelle. Toute reproduction, représentation, modification, publication, adaptation ou exploitation de tout ou partie des éléments du site, quel que soit le moyen ou le procédé utilisé, est interdite sans autorisation écrite préalable de la société Anticiper.
              </p>
            </div>

            <div>
              <h2 className="text-lg font-semibold text-slate-900 mb-3">4. Activité de formation</h2>
              <p className="text-sm text-slate-600 leading-relaxed">
                Anticiper exerce une activité de conception et de commercialisation de formations en ligne. À ce titre, la société est susceptible d'être enregistrée en tant qu'organisme de formation conformément aux dispositions des articles L.6351-1 et suivants du Code du travail. Les formations proposées sur le site sont présentées à titre informatif. Pour toute demande, veuillez contacter : contact@anticiper.net
              </p>
            </div>

            <div>
              <h2 className="text-lg font-semibold text-slate-900 mb-3">5. Liens hypertextes</h2>
              <p className="text-sm text-slate-600 leading-relaxed">
                Le site www.anticiper.net peut contenir des liens vers des sites tiers. Ces liens sont fournis à titre informatif uniquement. La société Anticiper n'exerce aucun contrôle sur ces sites et décline toute responsabilité quant à leur contenu, leurs pratiques ou leur politique de confidentialité.
              </p>
            </div>

            <div>
              <h2 className="text-lg font-semibold text-slate-900 mb-3">6. Limitation de responsabilité</h2>
              <p className="text-sm text-slate-600 leading-relaxed">
                La société Anticiper met tout en œuvre pour assurer l'exactitude et la mise à jour des informations diffusées sur ce site. Elle se réserve toutefois le droit de modifier ces informations à tout moment et sans préavis. Anticiper ne saurait être tenue responsable des dommages directs ou indirects résultant de l'utilisation du site ou de l'impossibilité d'y accéder.
              </p>
            </div>

            <div>
              <h2 className="text-lg font-semibold text-slate-900 mb-3">7. Droit applicable et juridiction compétente</h2>
              <p className="text-sm text-slate-600 leading-relaxed">
                Les présentes mentions légales sont soumises au droit français. En cas de litige, et à défaut de résolution amiable, les tribunaux français seront seuls compétents.
              </p>
            </div>

            <div>
              <h2 className="text-lg font-semibold text-slate-900 mb-3">8. Contact</h2>
              <p className="text-sm text-slate-600 leading-relaxed">
                Pour toute question relative aux présentes mentions légales, vous pouvez nous contacter :
              </p>
              <ul className="text-sm text-slate-600 space-y-1 ml-4 mt-2">
                <li><strong>Par email :</strong> contact@anticiper.net</li>
                <li><strong>Par courrier :</strong> Impact - BP 12 - Rue George Besse - 78330 Fontenay-le-Fleury</li>
              </ul>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
